// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"6bcb21f9","78":"6d50a450","281":"095ca4eb","392":"e6e411d7","489":"6c61a839","583":"ef46f35c","800":"05345623"}[chunkId] + ".chunk.js";
};